// @ vendor
const Immutable = require('immutable');
const map = require('lodash/collection/map');
const get = require('lodash/object/get');
const sortBy = require('lodash/collection/sortBy');
const { toCamelCase } = require('utilities/stringHelper');

const {
    LENGTH_POSTAL_CODE,
    SIZE_SLIDER_CONFIG,
    FLOW_STEPS,
} = require('../../insuranceConstants/insuranceRequestHome');

const {
    INSURANCE_REQUEST_CHANGE_ERROR_POSTAL_CODE,
    INSURANCE_REQUEST_CHANGE_ERROR_POPULATION,
    INSURANCE_REQUEST_WIZARD_LOAD_STEP,
    INSURANCE_REQUEST_WIZARD_VALIDATE_STEP,
    INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP,
    INSURANCE_REQUEST_WIZARD_SET_DATA,
    INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_SUCCESS,
    INSURANCE_REQUEST_SELECT_POPULATION_REQUEST,
    INSURANCE_REQUEST_SELECT_POPULATION_SUCCESS,
    INSURANCE_REQUEST_SELECT_POPULATION_FAILURE,
    INSURANCE_REQUEST_CLEAR_POSTAL_CODE_ERROR
} = require('../../insuranceConstants/actionTypes');

const setInitialState = () => {
    return Immutable.Map().merge({
        valid: false,
        validUI: false,
        fieldErrors: false,
        propertyCharacter: '',
        propertyUsage: '',
        postalCode: '',
        postalCodeError: false,
        isFetchingSelectPopulation: false,
        populationValue: null,
        population: null,
        populationError: false,
        populationOptions: [],
        propertyType: '',
        size: SIZE_SLIDER_CONFIG.DEFAULT,
        continent: 0,
        content: 0,
        simulationChanged: false
    });
};

const validatingPostalCode = postalCode => {
    return postalCode.length === LENGTH_POSTAL_CODE && !isNaN(postalCode);
}

const validateStep = (step, isNextButton = false) => {
    const continent = step.get('continent');
    const content = step.get('content');
    const population = step.get('population');
    const populationValue = step.get('populationValue');
    const populationOptionsIsEmpty = !step.get('populationOptions').size;
    const validPostalCode = validatingPostalCode(step.get('postalCode'));
    const postalCodeIsDirty = step.get('postalCodeIsDirty');
    const populationIsDirty = step.get('populationIsDirty');
    const propertyType = step.get('propertyType');
    const propertyCharacter = step.get('propertyCharacter');
    const propertyUsage = step.get('propertyUsage');
    const hasPopulation = !!populationValue || !!population;
    const valid = !!validPostalCode && continent !== 0 && content !== 0 && hasPopulation && !!propertyType
                && !!propertyCharacter && !!propertyUsage && !populationOptionsIsEmpty;
    return step.merge({
        valid,
        validUI: valid,
        postalCodeError: (isNextButton || postalCodeIsDirty) && (!validPostalCode || populationOptionsIsEmpty),
        populationError: (isNextButton || populationIsDirty) && !hasPopulation,
        fieldErrors: isNextButton
    });
};

const mapPopulationData = (step, populationData) => {
    const populationoptionsSorted = sortBy(populationData, population => population.populationLiterals);
    const populationOptions = map(populationoptionsSorted, population => {
        return {
            value: population.id,
            label: toCamelCase(population.populationLiterals),
            populationCode: population.populationCode
        };
    });

    const postalCodeError = populationOptions.length === 0;

    let populationValue;
    const population = step.get('population');
    if (populationOptions.length === 1) {
        populationValue = populationOptions[0].value;
    } else if(!!population){
        const populationString = toCamelCase(population);
        populationValue = populationString ?
            get(populationOptions.find(population => populationString === population.label), 'value', null) : null;
    }

    return step.merge({
        isFetchingSelectPopulation: false,
        postalCodeError,
        populationValue,
        populationOptions,
        populationError: false
    });
}

const validatePostalCodeError = (state) => {
    const validPostalCode = validatingPostalCode(state.get('postalCode'));
    const postalCodeError = !validPostalCode || !state.get('populationOptions').size;
    return state.merge({
        postalCodeError
    });

}

const validatePopulationError = (state) => {
    return state.merge({
        populationError: !state.get('populationValue'),
        populationIsDirty: true,
    });
}

const insuranceRequestWizardStep2 = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_WIZARD_VALIDATE_STEP:
            return validateStep(state, true);

        case INSURANCE_REQUEST_WIZARD_LOAD_STEP:
            const {
                population,
                propertyCharacter,
                propertyUsage,
                postalCode,
                propertyType,
                size,
            } = action.data.home;

            return state.merge({
                population,
                propertyCharacter,
                propertyUsage,
                postalCode,
                propertyType,
                size,
                continent: action.data.continent,
                content: action.data.content,
                valid: FLOW_STEPS[action.data.flowData.uiStep] > FLOW_STEPS.STEP_2
            });

        case INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP:
            return validateStep(state);

        case INSURANCE_REQUEST_WIZARD_SET_DATA:
            const partialState = state.merge({
                ...action.data,
                validUI: false,
            });

            const noValidateStep = action.data.noValidateStep;

            return noValidateStep ? partialState : validateStep(partialState);

        case INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_SUCCESS:
            return state.merge({
                simulationChanged: false,
            });
        case INSURANCE_REQUEST_SELECT_POPULATION_REQUEST:
            return state.merge({
                isFetchingSelectPopulation: true
            });
        case INSURANCE_REQUEST_SELECT_POPULATION_SUCCESS:
            return mapPopulationData(state, action.data.population);
        case INSURANCE_REQUEST_CHANGE_ERROR_POSTAL_CODE:
            return validatePostalCodeError(state);
        case INSURANCE_REQUEST_CHANGE_ERROR_POPULATION:
            return validatePopulationError(state);
        case INSURANCE_REQUEST_SELECT_POPULATION_FAILURE:
            return state.merge({
                isFetchingSelectPopulation: false,
                errorSelectPlan: action.data.error
            });
        case INSURANCE_REQUEST_CLEAR_POSTAL_CODE_ERROR:
            return state.merge({
                postalCodeError: false,
                populationError: false
            });
        default:
            return state;
    }
};

module.exports = insuranceRequestWizardStep2;
